define('ContactUsForm.Confirmation.View',
[
    'contactus_confirmation.tpl',
    'underscore',
    'Backbone'
],
function (contactus_confirmation,
          _,
          Backbone) {

    'use strict';

    return Backbone.View.extend({


        template: contactus_confirmation

        , initialize: function (options) {
        }

        , getContext: function () {
            return {
            };
        }

    })
})
